import styled from "styled-components";

export const PageBase = styled.div`
  background-color: #17192A;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
